/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { Card, Col, Container, Row } from "react-bootstrap";
import { Button } from "../../../components";
import DatePicker from "react-multi-date-picker";
import { useLocation, useNavigate } from "react-router-dom";
import {
  GetSellingProductDetails,
  GetSellingProductOrderHistory,
  GetSingleSellingProductHistory,
} from "../../../utilities/api/stock/sell";
import { toast } from "react-toastify";
import InputIcon from "react-multi-date-picker/components/input_icon";
import { CurrentMonth, CurrentYear } from "../../../utilities/utils";

const SellingInventoryDetails = () => {
  const id = useLocation().state;
  const navigate = useNavigate();
  const [data, setData] = useState({
    name: "",
    costPrice: "" || 0,
    soldQuantity: "",
    todaySoldQuantity: "",
    sellingPrice: "" || 0,
    availableQuantity: "",
  });

  const [salesMonth, setSalesMonth] = useState<string>(CurrentMonth);
  const [salesYear, setSalesYear] = useState<string>(CurrentYear);
  const [historyMonth, setHistoryMonth] = useState<string>(CurrentMonth);
  const [historyYear, setHistoryYear] = useState<string>(CurrentYear);
  const [HistoryData, setHistoryData] = useState([
    {
      changeCostPrice: 0,
      changeQuantity: 0,
      changeSellingPrice: 0,
      createdAt: "",
      id: 0,
      prevAvailableQuantity: 0,
      prevCostPrice: 0,
      prevSellingPrice: 0,
      productId: 0,
      remarkText: "",
    },
  ]);
  const [orderHistory, setOrderHistory] = useState<any[]>([]);

  const today = new Date();
  const maxDate = new Date(today.getFullYear(), today.getMonth(), 1);
  const minDate = new Date(2023, 0, 1);

  const handleSalesChange = (date: any) => {
    setSalesMonth(date?.format("MM"));
    setSalesYear(date?.format("YYYY"));
  };
  const handleHistoryChange = (date: any) => {
    setHistoryMonth(date?.format("MM"));
    setHistoryYear(date?.format("YYYY"));
  };

  const GetData = async () => {
    const result = await GetSellingProductDetails(id);
    if (result.statusCode === 200) {
      let sellData = result.data;
      setData({
        name: sellData.name,
        costPrice: sellData.costPrice,
        soldQuantity: sellData.soldQuantity,
        todaySoldQuantity: sellData.todaySoldQuantity,
        sellingPrice: sellData.sellingPrice,
        availableQuantity: sellData.availableQuantity,
      });
    } else {
      toast.error(result.response.data.message);
    }
  };

  const GetHistory = async () => {
    const result = await GetSingleSellingProductHistory(
      id,
      historyYear,
      historyMonth
    );
    if (result.statusCode === 200) {
      setHistoryData(result.data.rows);
    } else {
      toast.error(result.response.data.message);
    }
  };

  const GetSellOrderHistory = async () => {
    const result = await GetSellingProductOrderHistory(
      id,
      salesYear,
      salesMonth
    );
    if (result.statusCode === 200) {
      setOrderHistory(result.data.rows);
    } else {
      toast.error(result.response.data.message);
    }
  };

  useEffect(() => {
    GetHistory();
  }, [historyMonth, historyYear]);

  useEffect(() => {
    GetSellOrderHistory();
  }, [salesMonth, salesYear]);

  useEffect(() => {
    GetData();
  }, []);

  const handleBack = () => {
    navigate("/sell-stock");
  };

  return (
    <>
      <Container fluid className="g-0">
        <Card>
          <Card.Body>
            <div className="page-title align-items-center d-flex justify-content-between">
              <Card.Title className="mb-0">Sales Stock Details</Card.Title>
            </div>
            <hr />
            <Row className="text-start">
              <Col lg={6}>
                <div className="fw-semibold mb-3">
                  Product Name: <span className="text-info">{data.name}</span>{" "}
                </div>
              </Col>
              <Col lg={6}>
                <div className="fw-semibold mb-3">
                  Purchased Price per Unit:{" "}
                  <span className="text-info">
                    <span className="rupees-symbol">&#8377;</span>{" "}
                    {data.costPrice?.toFixed(2)}
                  </span>{" "}
                </div>
              </Col>
              <Col lg={6}>
                <div className="fw-semibold mb-3">
                  Sold Today:{" "}
                  <span className="text-info">{data.todaySoldQuantity}</span>{" "}
                </div>
              </Col>
              <Col lg={6}>
                <div className="fw-semibold mb-3">
                  Selling Price per Unit:{" "}
                  <span className="text-info">
                    <span className="rupees-symbol">&#8377;</span>{" "}
                    {data.sellingPrice?.toFixed(2)}
                  </span>{" "}
                </div>
              </Col>
              <Col lg={6}>
                <div className="fw-semibold mb-3">
                  Available Quantity:{" "}
                  <span className="text-info">{data.availableQuantity}</span>{" "}
                </div>
              </Col>
            </Row>
            <Row className="align-items-center">
              <Col lg={12}>
                <div className="mb-3 text-start">
                  <label
                    htmlFor="viewsalesdata"
                    className="form-label fw-semibold"
                  >
                    Sold History:{" "}
                  </label>{" "}
                  <DatePicker
                    value={new Date(`${salesMonth}/01/${salesYear}`)}
                    onlyMonthPicker
                    format="MM/YYYY"
                    onChange={handleSalesChange}
                    minDate={minDate}
                    maxDate={maxDate}
                    placeholder="Select Date"
                    render={<InputIcon className="form-control" />}
                  />
                </div>
                <table className="table table-bordered table-hover table-sm mb-3">
                  <thead>
                    <tr>
                      <th>Sales Date</th>
                      <th>Sold Quantity</th>
                      <th>Sold Price</th>
                      <th>Total Amount</th>
                    </tr>
                  </thead>
                  <tbody>
                    {orderHistory.length ? (
                      orderHistory.map((item, index) => {
                        return (
                          <tr key={"sold-history-" + item.id}>
                            <td>{item?.createdAt}</td>
                            <td>{item?.quantity}</td>
                            <td>{item?.sellingPrice}</td>
                            <td>{item?.totalAmount}</td>
                          </tr>
                        );
                      })
                    ) : (
                      <tr>
                        <td
                          colSpan={4}
                          className="bg-opacity-75 text-bg-danger"
                        >
                          No Records Found
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </Col>
              <Col lg={12}>
                <div className="mb-3 text-start">
                  <label htmlFor="viewdata" className="form-label fw-semibold">
                    Inventory History:{" "}
                  </label>{" "}
                  <DatePicker
                    value={new Date(`${historyMonth}/01/${historyYear}`)}
                    onlyMonthPicker
                    format="MM/YYYY"
                    onChange={handleHistoryChange}
                    minDate={minDate}
                    maxDate={maxDate}
                    placeholder="Select Date"
                    render={<InputIcon className="form-control" />}
                  />
                </div>
                <table className="table table-bordered table-hover table-sm mb-3">
                  <thead>
                    <tr>
                      <th>Date</th>
                      <th>Previous Quantity</th>
                      <th>Current Quantity</th>
                      <th>Purchased Price</th>
                      <th>Previous Selling Price</th>
                      <th>Current Selling Price</th>
                      <th>Remarks</th>
                    </tr>
                  </thead>
                  <tbody>
                    {HistoryData.length ? (
                      HistoryData.map((item: any, index) => {
                        return (
                          <tr key={"sold-inventory-" + item.id}>
                            <td>{item.createdAt}</td>
                            <td>{item.prevAvailableQuantity}</td>
                            <td
                              className={
                                item.changeQuantity > 0
                                  ? "text-success"
                                  : item.changeQuantity < 0
                                    ? "text-danger"
                                    : ""
                              }
                            >
                              {item.prevAvailableQuantity + item.changeQuantity}
                            </td>
                            <td>{item.prevCostPrice}</td>
                            <td>{item.prevSellingPrice}</td>
                            <td
                              className={
                                item.changeSellingPrice > 0
                                  ? "text-success"
                                  : item.changeSellingPrice < 0
                                    ? "text-danger"
                                    : ""
                              }
                            >
                              {item.prevSellingPrice + item.changeSellingPrice}
                            </td>
                            <td>{item.remarkText}</td>
                          </tr>
                        );
                      })
                    ) : (
                      <tr>
                        <td
                          colSpan={7}
                          className="bg-opacity-75 text-bg-danger"
                        >
                          No Records Found
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </Col>
            </Row>
            <hr />
            <Row>
              <Col className="text-end">
                <Button
                  onClick={handleBack}
                  type="button"
                  bname="Ok"
                  name="ok"
                  id="ok"
                  className="btn btn-primary rounded-1 "
                ></Button>
              </Col>
            </Row>
          </Card.Body>
        </Card>
      </Container>
    </>
  );
};
export { SellingInventoryDetails };
